/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @ngrx/prefer-effect-callback-in-block-statement */
/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { CandidateService } from 'src/app/recruiting/candidates/candidate.service';
import { LiveCandidateDetails } from 'src/app/recruiting/candidates/details/models/live-candidate-details.model';
import { LiveCandidateItems } from 'src/app/recruiting/candidates/details/models/live-candidate-item.model';
import { RecruitingService } from 'src/app/recruiting/recruiting.service';
import { JobsService as SharedJobsService } from 'src/app/shared/services/jobs.service';
import { LeadQueueService } from 'src/app/lead-queue/lead-queue.service';

import {
    dashboardGetAllHotCandidates,
    dashboardGetAllHotCandidatesFail,
    dashboardGetAllHotCandidatesSuccess,
    dashboardGetAllLeadCandidates,
    dashboardGetAllLeadCandidatesSuccess,
    dashboardGetAllLiveCandidates,
    dashboardGetAllLiveCandidatesSuccess,
    dashboardGetAllPreCandidates,
    dashboardGetAllPreCandidatesFail,
    dashboardGetAllPreCandidatesSuccess,
    dashboardGetAllSelfApplyCandidates,
    dashboardGetAllSelfApplyCandidatesSuccess,
    dashboardGetAllWorCandidates,
    dashboardGetAllWorCandidatesFail,
    dashboardGetAllWorCandidatesSuccess,
    dashboardGetHotCandidates,
    dashboardGetHotCandidatesFail,
    dashboardGetHotCandidatesSuccess,
    dashboardGetHotDetails,
    dashboardGetHotDetailsFail,
    dashboardGetHotDetailsSuccess,
    dashboardGetJobInterest,
    dashboardGetJobInterestFail,
    dashboardGetJobInterestSuccess,
    dashboardGetLiveCandidates,
    dashboardGetLiveCandidatesFail,
    dashboardGetLiveCandidatesSuccess,
    dashboardGetLiveDetails,
    dashboardGetLiveDetailsFail,
    dashboardGetLiveDetailsSuccess,
    dashboardGetPendingHotCandidates,
    dashboardGetPendingHotCandidatesFail,
    dashboardGetPendingHotCandidatesSuccess,
    dashboardGetPreCandidates,
    dashboardGetPreCandidatesFail,
    dashboardGetPreCandidatesSuccess,
    dashboardGetPreDetails,
    dashboardGetPreDetailsFail,
    dashboardGetPreDetailsSuccess,
    dashboardGetRecruiterLeadQueueStatus,
    dashboardGetRecruiterLeadQueueStatusSuccess,
    dashboardGetRecruiterLeadQueueStatusFail,
    dashboardGetSelfApplyCandidates,
    dashboardGetSelfApplyCandidatesFail,
    dashboardGetSelfApplyCandidatesSuccess,
    dashboardGetTileFollowups,
    dashboardGetTileFollowupsFail,
    dashboardGetTileFollowupsSuccess,
    dashboardGetWorCandidates,
    dashboardGetWorCandidatesFail,
    dashboardGetWorCandidatesSuccess,
    dashboardGetWorDetails,
    dashboardGetWorDetailsFail,
    dashboardGetWorDetailsSuccess,
    dashboardUpdateRecruiterLeadQueueStatusSuccess,
    dashboardUpdateRecruiterLeadQueueStatus,
    dashboardUpdateRecruiterLeadQueueStatusFail
} from '../actions/dashboard.actions';
import { HttpResponseHelpers } from 'src/app/shared/helpers';

@Injectable()
export class DashboardEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _recruitingService: RecruitingService,
        private readonly _candidateService: CandidateService,
        private readonly _jobsService: SharedJobsService,
        private readonly _leadQueueService: LeadQueueService
    ) {}

    dashboardGetHotCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetHotCandidates),
            switchMap((action) => {
                return this._candidateService
                    .getRecruiterHotItems(action.recruiterId, action.maxItems, action.refOnly)
                    .pipe(
                        map((hotCandidates) => dashboardGetHotCandidatesSuccess({ hots: hotCandidates })),
                        catchError((error) => of(dashboardGetHotCandidatesFail({ error })))
                    );
            })
        )
    );

    dashboardGetAllHotCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetAllHotCandidates),
            switchMap((action) => {
                return this._candidateService
                    .getRecruiterHotItems(action.recruiterId, action.maxItems, action.refOnly)
                    .pipe(
                        map((hotCandidates) => dashboardGetAllHotCandidatesSuccess({ hots: hotCandidates })),
                        catchError((error) => of(dashboardGetAllHotCandidatesFail({ error })))
                    );
            })
        )
    );

    dashboardGetPendHotCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetPendingHotCandidates),
            switchMap((action) => {
                return this._candidateService.getRecruiterHotItems(action.recruiterId, action.maxItems, true).pipe(
                    map((hotCandidates) => dashboardGetPendingHotCandidatesSuccess({ hots: hotCandidates })),
                    catchError((error) => of(dashboardGetPendingHotCandidatesFail({ error })))
                );
            })
        )
    );

    dashboardGetHotDetails$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetHotDetails),
            switchMap((action) => {
                return this._candidateService.getRecruiterHotDetails(action.candidateId).pipe(
                    map((hotCandidate) => dashboardGetHotDetailsSuccess({ hotDetail: hotCandidate })),
                    catchError((error) => of(dashboardGetHotDetailsFail({ error })))
                );
            })
        )
    );

    private readonly _getJobSuggestionsForLiveCandidateItems = switchMap<
        LiveCandidateItems,
        Observable<LiveCandidateItems>
    >((candidates) => {
        const userIds = candidates?.items?.map((c) => c?.candidateId);
        return !userIds?.length
            ? of(candidates)
            : this._jobsService.getJobSuggestions(userIds).pipe(
                  map((jobs) => {
                      candidates?.items?.forEach((c) => {
                          c.systemSuggestedJobs = jobs?.filter((j) => j?.userId > 0 && j.userId === c.candidateId);
                      });
                      return candidates;
                  }),
                  catchError(() => of(candidates))
              );
    });

    private readonly _getJobSuggestionsForLiveCandidateDetails = switchMap<
        LiveCandidateDetails,
        Observable<LiveCandidateDetails>
    >((candidate) => {
        return !candidate?.userId
            ? of(candidate)
            : this._jobsService.getJobSuggestions([candidate.userId]).pipe(
                  map((jobs) => {
                      candidate.systemSuggestedJobs = jobs;
                      return candidate;
                  }),
                  catchError(() => of(candidate))
              );
    });

    dashboardGetLiveCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetLiveCandidates),
            switchMap((action) => this._candidateService.getLiveCandidateItems(action.recruiterId, action.maxItems)),
            this._getJobSuggestionsForLiveCandidateItems,
            map((lives) => dashboardGetLiveCandidatesSuccess({ lives })),
            catchError((error) => of(dashboardGetLiveCandidatesFail({ error })))
        )
    );

    dashboardGetAllLiveCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetAllLiveCandidates),
            switchMap((action) => this._candidateService.getAllLiveCandidateItems(action.recruiterId)),
            this._getJobSuggestionsForLiveCandidateItems,
            map((lives) => dashboardGetAllLiveCandidatesSuccess({ lives })),
            catchError((error) => of(dashboardGetLiveCandidatesFail({ error })))
        )
    );

    dashboardGetLiveDetails$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetLiveDetails),
            switchMap((action) => this._candidateService.getLiveCandidateDetails(action.candidateId)),
            this._getJobSuggestionsForLiveCandidateDetails,
            map((details) => dashboardGetLiveDetailsSuccess({ details })),
            catchError((error) => of(dashboardGetLiveDetailsFail({ error })))
        )
    );

    dashboardGetPreCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetPreCandidates),
            switchMap((action) => {
                return this._candidateService.getPreStartItems(action.recruiterId, action.maxItems).pipe(
                    map((preCandidates) => dashboardGetPreCandidatesSuccess({ items: preCandidates })),
                    catchError((error) => of(dashboardGetPreCandidatesFail({ error })))
                );
            })
        )
    );

    dashboardGetAllPreCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetAllPreCandidates),
            switchMap((action) => {
                return this._candidateService.getAllPreStartItems(action.recruiterId).pipe(
                    map((preCandidates) => dashboardGetAllPreCandidatesSuccess({ data: preCandidates })),
                    catchError((error) => of(dashboardGetAllPreCandidatesFail({ error })))
                );
            })
        )
    );

    dashboardGetPreDetails$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetPreDetails),
            switchMap((action) => {
                return this._candidateService.getPreStartDetails(action.candidateId).pipe(
                    map((preDetails) => dashboardGetPreDetailsSuccess({ data: preDetails })),
                    catchError((error) => of(dashboardGetPreDetailsFail({ error })))
                );
            })
        )
    );

    dashboardGetWorCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetWorCandidates),
            switchMap((action) => {
                return this._candidateService.getWorkingItems(action.recruiterId, action.maxItems).pipe(
                    map((worCandidates) => dashboardGetWorCandidatesSuccess({ items: worCandidates })),
                    catchError((error) => of(dashboardGetWorCandidatesFail({ error })))
                );
            })
        )
    );

    dashboardGetAllWorCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetAllWorCandidates),
            switchMap((action) => {
                return this._candidateService.getAllWorkingItems(action.recruiterId).pipe(
                    map((worCandidates) => dashboardGetAllWorCandidatesSuccess({ data: worCandidates })),
                    catchError((error) => of(dashboardGetAllWorCandidatesFail({ error })))
                );
            })
        )
    );

    dashboardGetWorDetails$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetWorDetails),
            switchMap((action) => {
                return this._candidateService.getWorkingDetails(action.candidateId).pipe(
                    map((worDetails) => dashboardGetWorDetailsSuccess({ data: worDetails })),
                    catchError((error) => of(dashboardGetWorDetailsFail({ error })))
                );
            })
        )
    );

    dashboardGetJobInterest$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetJobInterest),
            switchMap((action) => {
                return this._candidateService.getRecruiterJobInterest(action.recruiterId).pipe(
                    map((jobInterestItems) => dashboardGetJobInterestSuccess({ data: jobInterestItems })),
                    catchError((error) => of(dashboardGetJobInterestFail({ error })))
                );
            })
        )
    );

    dashboardGetAllLeadCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetAllLeadCandidates),
            switchMap((action) => {
                return this._candidateService.getAllLeadCandidateItems(action.recruiterId).pipe(
                    map((leadCandidates) => dashboardGetAllLeadCandidatesSuccess({ leads: leadCandidates })),
                    catchError((error) => of(dashboardGetLiveCandidatesFail({ error })))
                );
            })
        )
    );

    dashboardGetTileFollowups$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetTileFollowups),
            switchMap((action) => {
                return this._recruitingService.getDashboardTileFollowups(action.recruiterId).pipe(
                    map((tileFollowups) => dashboardGetTileFollowupsSuccess({ data: tileFollowups })),
                    catchError((error) => of(dashboardGetTileFollowupsFail({ error })))
                );
            })
        )
    );

    dashboardGetSelfApplyCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetSelfApplyCandidates),
            switchMap((action) => {
                return this._candidateService.getRecruiterSelfApplyCandidates(action.recruiterId, action.filter).pipe(
                    map((candidates) => dashboardGetSelfApplyCandidatesSuccess({ selfApplyCandidates: candidates })),
                    catchError((error) => of(dashboardGetSelfApplyCandidatesFail({ error })))
                );
            })
        )
    );

    dashboardGetAllSelfApplyCandidates$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetAllSelfApplyCandidates),
            switchMap((action) => {
                return this._candidateService.getRecruiterSelfApplyCandidates(action.recruiterId, action.filter).pipe(
                    map((candidates) => dashboardGetAllSelfApplyCandidatesSuccess({ selfApplyCandidates: candidates })),
                    catchError((error) => of(dashboardGetSelfApplyCandidatesFail({ error })))
                );
            })
        )
    );

    dashboardGetRecruiterLeadQueuePauseStatus$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardGetRecruiterLeadQueueStatus),
            switchMap((action) => {
                return this._leadQueueService.getRecruiterLeadQueueInfoStatus(action?.recruiterId).pipe(
                    map((leadInfoStatus) =>
                        dashboardGetRecruiterLeadQueueStatusSuccess({
                            recruiterLeadInfoStatus: leadInfoStatus
                        })
                    ),
                    catchError((error) => of(dashboardGetRecruiterLeadQueueStatusFail({ error })))
                );
            })
        )
    );

    dashboardUpdateRecruiterLeadQueueStatus$ = createEffect(() =>
        this._actions$.pipe(
            ofType(dashboardUpdateRecruiterLeadQueueStatus),
            switchMap((action) => {
                return this._leadQueueService.setRecruiterStatus(action.leadInfoId, action.status).pipe(
                    map((leadInfo) =>
                        dashboardUpdateRecruiterLeadQueueStatusSuccess({
                            recruiterLeadInfoStatus: leadInfo
                        })
                    ),
                    catchError((error) =>
                        of(
                            dashboardUpdateRecruiterLeadQueueStatusFail({
                                error: HttpResponseHelpers.parseErrorResponse(error)
                            })
                        )
                    )
                );
            })
        )
    );
}
